export default __webpack_public_path__ + "static/box-usage-example-1724ee6af438a6c2e269316d8bf552e269f054896d0cceab60a1be4fd925b82a.png";